<template>
  <vx-card class="vx-card_full-height">
    <div v-if="!error" :class="$style.container">
      <div :class="$style.main">
        <div :class="$style.back">
          <vs-button :to="{name: 'uc_b_payments'}" type="border" icon="keyboard_backspace" tag="a">
            К списку платежей
          </vs-button>
        </div>
        <div :class="$style.title">
          Платеж от <b v-if="payment">{{ formatDate(payment.payment_create_date) }}</b> на сумму
          <b v-if="payment">{{ payment.amount | money }}</b>
        </div>

        <div :class="$style.monthForm">
          <div :class="$style.monthDatepicker">
            <elsa-v-datepicker
              label="Месяц назначения"
              v-model="month"
              :disabled="!monthEditActive"
              view-format="LLLL yyyy"
              :datepicker-props="{minimumView: 'month'}"
            />
          </div>
          <vs-button v-if="!monthEditActive" @click="monthEditActive = true" type="border" color="success">
            Изменить
          </vs-button>
          <div class="mr-2">
            <vs-button
              v-if="monthEditActive"
              @click="onChangeMonth"
              iconPack="feather"
              icon="icon-check"
              color="success"
            >
              Подтвердить
            </vs-button>
          </div>
          <div>
            <vs-button v-if="monthEditActive" @click="monthEditActive = false" type="flat">
              Отмена
            </vs-button>
          </div>
        </div>
        <div v-if="monthEditActive" :class="$style.monthNote">
          <feather-icon :svg-classes="$style.monthNoteIcon" icon="AlertTriangleIcon" />
          При изменении месяца назначения платеж будет перераспределен.
        </div>

        <div :class="$style.paymentsTitle">Распределено</div>
        <table v-if="allocations" :class="$style.payments">
          <tbody>
          <tr v-for="allocation in allocations" :key="allocation.id" :class="$style.payment">
            <td :class="$style.paymentMonth">{{ allocation.month }}</td>
            <td :class="$style.paymentType">{{ allocation.target }}</td>
            <td :class="$style.paymentAmount">{{ allocation.amount }}</td>
            <td><span v-if="allocation.manual" :class="$style.paymentNote">Распределено вручную</span></td>
          </tr>
          </tbody>
        </table>

        <div :class="$style.recalc">
          <vs-button
            color="success"
            type="border"
            @click="onAllocate"
          >
            Перераспределить вручную
          </vs-button>
        </div>

        <div :class="$style.note">
          При полном погашении всех задолженностей остаток платежа попадает на пополнение баланса лицевого счета.
        </div>

        <div :class="$style.label">
          Платеж создан пользователем:
          <span v-if="payment">{{ payment.author ? payment.author.name : '-' }}</span>
        </div>
        <div v-if="manualAllocation" :class="$style.label">
          Последний раз платеж перераспределялся пользователем: {{ manualAllocation.user.name }},
          {{ formatDate(manualAllocation.updated_at) }}
        </div>
      </div>

      <div :class="$style.aside">
        <div :class="$style.card">
          <div :class="$style.cardHeader">Платежная информация</div>
          <div :class="$style.cardBody">
            <div :class="$style.info">
              <b>Лицевой счет: </b>
              <router-link v-if="payment" :to="{ name: 'uc_b_account', params: {id: payment.account_number}}">
                {{ payment.account_number }}
              </router-link>
            </div>
            <div :class="$style.info">
              <b>Тип: </b>
              <dictionary-item v-if="payment" :dictionary="paymentTypes" :id="payment.type" />
            </div>
            <div :class="$style.info">
              <b>Добавлено в систему: </b>
              <span v-if="payment">{{ formatDate(payment.payment_passage_date) }}</span>
            </div>
            <div :class="$style.info">
              <b>Проведено по банку: </b>
              <span v-if="payment">{{ formatDate(payment.payment_create_date) }}</span>
            </div>
            <div :class="$style.info">
              <b>Зачислено: </b>
              <span v-if="payment">{{ payment.amount | money }}</span>
            </div>
            <div :class="$style.info">
              <b>Комиссия: </b>
              <span v-if="payment">{{ payment.amount_agency | money }}</span>
            </div>
            <div :class="$style.info">
              <b>Сумма: </b>
              <span v-if="payment">{{ payment.all_amount | money }}</span>
            </div>
            <div :class="$style.info">
              <vs-checkbox v-model="checkPrinted" :disabled="checkPrinted" @change="onPrintCheck">
                Чек распечатан
              </vs-checkbox>
            </div>
            <div v-if="payment">
              <div v-if="payment.check_print">
                <div :class="$style.info">
                  <b>Номер чека: </b>
                  <a v-if="payment.check_anchor" :href="payment.check_anchor" target="_blank">
                    {{ payment.check_number }}
                  </a>
                  <span v-else>{{ payment.check_number }}</span>
                </div>
                <div :class="$style.infoNote">Чек уже сформирован, редактировать или удалить платеж нельзя.</div>
              </div>
              <div v-else-if="$can('rp.invoices', 'write')" :class="$style.infoActions">
                <vs-button :class="$style.infoAction" type="border" iconPack="feather" icon="icon-edit" @click="onEdit">
                  Редактировать
                </vs-button>
                <vs-button
                  :class="$style.infoAction"
                  type="border"
                  iconPack="feather"
                  icon="icon-trash"
                  color="danger"
                  @click="onRemove"
                >
                  Удалить платеж
                </vs-button>
              </div>
            </div>
          </div>
        </div>

        <div :class="$style.card">
          <div :class="$style.cardHeader">Комментарий</div>

          <payment-comment :value="payment ? payment.comment : ''" :on-change="onUpdateComment" />
        </div>
      </div>

      <div v-if="loading" class="block-loading-container">
        <div class="block-loading" />
      </div>
    </div>
    <div v-else :class="$style.error">
      <div>{{ error }}</div>
      <vs-button :to="{name: 'uc_b_payments'}" type="border" icon="keyboard_backspace" tag="a">
        К списку платежей
      </vs-button>
    </div>
  </vx-card>
</template>

<script>
import notifyHttpError                                                    from "@/mixins/notifyHttpError";
import DictionaryItem                                                     from "@/components/DictionaryItem";
import paymentTypes                                                       from "@/dictionaries/paymentTypes";
import formatDate                                                         from "@/client/helpers/formatDate";
import parseDate                                                          from "@/client/helpers/parseDate";
import { formatMoney }                                                    from "@/client/filters/money";
import { getHttpError }                                                   from "@/helpers/getHttpError";
import { getCommonError }                                                 from "@/helpers/mergeCommonErrors";
import PaymentComment                                                     from "@/components/payment/PaymentComment";
import { PAYMENT_TARGET_CHARGE, PAYMENT_TARGET_FINE, paymentTargetsDict } from "@/dictionaries/paymentTargets";
import currency                                                           from "currency.js";

export default {
  name:       "Payment",
  components: { PaymentComment, DictionaryItem },
  mixins:     [notifyHttpError],
  data() {
    return {
      error:            null,
      loading:          false,
      paymentTypes,
      payment:          null,
      monthEditActive:  false,
      month:            null,
      checkPrinted:     false,
      allocations:      null,
      manualAllocation: null,
    };
  },
  computed: {
    selectedBuildingId() {
      return this.$store.getters['appUser/selectedHouseId'];
    },
  },
  methods:  {
    formatDate,

    updatePayment( data ) {
      const { params: { id } } = this.$route;
      return this.$http.put(`invoice/${id}`, {
        ...this.payment,
        ...data,
      }).then(
        () => this.loadAll(),
        this.notifyHttpError,
      );
    },

    deletePayment() {
      const { params: { id } } = this.$route;
      return this.$http.delete(`invoice/${id}`, { params: { buildings_id: this.selectedBuildingId } }).catch(this.notifyHttpError);
    },

    loadAll() {
      return Promise.all([
        this.loadPayment(),
        this.loadAllocations(),
        this.loadManualAllocations(),
      ]);
    },

    loadPayment() {
      const { params: { id } } = this.$route;
      return this.$http.get(`invoice/${id}`, { params: { buildings_id: this.selectedBuildingId } }).then(
        ( { data } ) => {
          this.payment = data;
          this.checkPrinted = !!data.check_print;
          this.month = parseDate(data.monthyear);
        },
        ( err ) => {
          this.error = getCommonError(getHttpError(err));
          console.log(err.response);
        },
      );
    },

    loadAllocations() {
      const { params: { id } } = this.$route;
      return this.$http.get(`/invoice/${id}/allocations`, { params: { buildings_id: this.selectedBuildingId } }).then(( { data } ) => {
        const { chargeAllocations, fineAllocations } = data;

        const allocations = [];
        const addAllocation = target => allocation => {
          allocations.push({
            id:     allocation.id,
            month:  formatDate(allocation.month, 'LLLL yyyy'),
            target: paymentTargetsDict[target].name,
            amount: formatMoney(allocation.amount, false),
            manual: !!allocation.manual_allocation,
          });
        };
        chargeAllocations.forEach(addAllocation(PAYMENT_TARGET_CHARGE));
        fineAllocations.forEach(addAllocation(PAYMENT_TARGET_FINE));

        this.allocations = allocations;
      });
    },

    loadManualAllocations() {
      const { params: { id } } = this.$route;
      return this.$http.get(`/invoice/${id}/manual_allocation`, { params: { buildings_id: this.selectedBuildingId } })
        .then(
          ( { data } ) => this.manualAllocation = data,
          () => this.manualAllocation = null,
        );
    },

    onChangeMonth() {
      this.monthEditActive = false;
      const monthyear = formatDate(this.month, 'yyyy-MM');
      this.loading = true;
      return this.updatePayment({ monthyear }).finally(() => {
        this.loading = false;
      });
    },

    onAllocate() {
      const allocations = [];
      if (this.manualAllocation) {
        const { parameters: { fines, charges } } = this.manualAllocation;
        const addAllocation = target => allocation => allocations.push({
          month:  parseDate(allocation.month),
          target,
          amount: allocation.sum,
        });
        if (Array.isArray(charges)) charges.forEach(addAllocation(PAYMENT_TARGET_CHARGE));
        if (Array.isArray(fines)) fines.forEach(addAllocation(PAYMENT_TARGET_FINE));
      }
      this.$modal.open({
        title:          'Изменить назначения платежа',
        component:      () => import('@/components/payment/AllocatePaymentPopup'),
        componentProps: {
          payment:     this.payment,
          allocations: allocations,
          onSubmit:    ( rows ) => {
            const { id, buildings_id } = this.payment;
            const parameters = {
              charges: [],
              fines:   [],
            };
            rows.forEach(row => {
              const key = row.target === PAYMENT_TARGET_CHARGE ? 'charges' : 'fines';
              parameters[key].push({
                "month": formatDate(row.month, 'yyyy-MM'),
                "sum":   currency(row.amount).value,
              });
            });

            let request;
            if (parameters.charges.length || parameters.fines.length) {
              request = this.manualAllocation
                ? this.$http.put(`manual_allocation/${this.manualAllocation.id}`, { buildings_id, parameters })
                : this.$http.post(`invoice/${id}/manual_allocation`, { buildings_id, parameters });
            } else {
              request = this.manualAllocation
                ? this.$http.delete(`manual_allocation/${this.manualAllocation.id}`, {
                  params: {
                    buildings_id,
                    parameters,
                  },
                })
                : Promise.resolve();
            }

            return request.then(
              () => this.loadAll(),
              this.notifyHttpError,
            );
          },
        },
      });
    },

    onPrintCheck() {
      this.$modal.open({
        size:           'sm',
        title:          'Укажите номер чека',
        component:      () => import('@/components/payment/SetCheckNumberPopup'),
        componentProps: {
          onSubmit: ( { number } ) => {
            return this.updatePayment({
              check_print:  true,
              check_number: number,
            });
          },
        },
      }).result.then(
        () => {},
        () => {
          this.checkPrinted = false;
        },
      );
    },

    onEdit() {
      this.$modal.open({
        size:           'sm',
        title:          'Платежная информация',
        component:      () => import('@/components/payment/EditPaymentPopup'),
        componentProps: {
          payment:  this.payment,
          onSubmit: ( data ) => {
            return this.updatePayment(data);
          },
        },
      }).result.then(
        () => {},
        () => {},
      );
    },

    onUpdateComment( comment ) {
      return this.updatePayment({ comment });
    },

    onRemove() {
      this.$modal.openConfirm({
        message:     'Вы уверены что хотите удалить платеж?',
        buttonText:  'Удалить',
        buttonColor: 'danger',
        // size,
        onAccept: () => {
          return this.deletePayment().then(() => {
            this.$router.push({ name: 'uc_b_payments' });
          });
        },
      });
    },
  },
  mounted() {
    this.loadAll();
  },
  watch: {},
};
</script>

<style lang="scss" module>
.container {
  display: flex;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.aside {
  width: 400px;
  margin-left: 20px;
}

.back {
  margin-bottom: 1em;
}

.title {
  font-size: 19px;
  margin-bottom: .75em;
}

.card {
  border: 1px solid #A9A9A9;
  border-radius: 4px;
  margin-bottom: 20px;
  overflow: hidden;
}

.cardHeader {
  background: #F3F3F3;
  font-size: 18px;
  padding: 9px 10px;
  border-bottom: 1px solid #A9A9A9;
  border-radius: 4px 4px 0 0;
}

.cardBody {
  padding: 20px;
}

.info {
  font-size: 15px;
  margin-bottom: 12px;
}

.infoNote {
  font-size: 15px;
  opacity: .4;
}

.infoActions {
  display: flex;
  margin: 0 -5px;
}

.infoAction {
  padding-left: 0 !important;
  padding-right: 0 !important;
  flex: 1;
  margin: 0 5px;
}

.monthForm {
  display: flex;
  align-items: flex-end;
  width: 100%;
}

.monthDatepicker {
  flex: 1;
  max-width: 380px;
  margin-right: 6px;
}

.monthNote {
  color: color(danger);
  font-size: 15px;
  margin-top: 13px;
  display: flex;
  align-items: center;
}

.monthNoteIcon {
  width: 14px;
  height: 14px;
  margin-right: 5px;
}

.paymentsTitle {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 28px;
}

.payments {
  margin-bottom: 24px;
  border-spacing: 0;
}

.payment {
  font-size: 19px;

  &:last-child {
    td {
      border: 0;
    }
  }

  td {
    height: 36px;
    border-bottom: 1px solid rgba(#000, .2);

  }
}

.paymentMonth {
  width: 190px;
}

.paymentType {
  width: 215px;
}

.paymentAmount {
  //min-width: 130px;
  padding-right: 20px;
  flex: 1;
}

.paymentNote {
  display: block;
  font-size: 14px;
  opacity: .5;
  text-align: right;
  margin-left: auto;
  line-height: 1;
}

.recalc {
  margin-bottom: 24px;
}

.note {
  font-size: 16px;
  margin-bottom: 16px;
}

.label {
  margin-bottom: 8px;
  font-size: 13px;
  opacity: .75;
}

.error {
  flex: 1;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  color: color(danger);
  font-style: italic;
}
</style>
